import { css, html } from "lit";
import { customElement, state } from "lit/decorators.js";
import { Style } from "../Styles";
import { BaseElement } from "../BaseElement";
import { MapBounds } from "../../Kernel";
import { getPlacesInBoundingBox } from "../../models/ILocation";
import { PlaceTable } from "../../backend/cloud/PlaceTable";
import { IPlace } from "../../models/Models";

@customElement("ds-map-cache-place-media-control")
export class MapCachePlaceMediaControl extends BaseElement {
    static override styles = [
        Style,
        css`
            :host {
                display: block;
            }
        `,
    ];

    @state() protected _sitesInViewport: IPlace[] = [];
    @state() protected _mapBounds: MapBounds | undefined;

    private _placeTable = this._kernel.dataStore.getSource<PlaceTable>("places");

    public override async connectedCallback(): Promise<void> {
        super.connectedCallback();
        this._mapBounds = this._kernel.getMapBounds();
        await this._update();
    }

    private async _update() {
        if (this._mapBounds) {
            const filter = this._kernel.currentPlaceFilter.get();
            const allPlaces = this._placeTable
                .allFilteredItems(filter)
                .filter((x) => x.data.locationKnown);

            this._sitesInViewport = getPlacesInBoundingBox(allPlaces, this._mapBounds);
        }
    }

    private async _startCaching() {
        if (this._sitesInViewport.length > 0) {
            this._kernel.placeMediaDownloader.startJob(
                this._sitesInViewport.map((x) => x.id),
                "Place media",
                {}
            );
            this._raiseEvent("ds-download-started");
        }
    }

    override render() {
        return html`<div class="flex-column">
            <span>${this._sitesInViewport.length} places in viewport</span>
            <sl-button @click=${() => this._startCaching()}>Cache place media</sl-button>
        </div>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-map-cache-place-media-control": MapCachePlaceMediaControl;
    }
}
